// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2QrAJ","header":"PatientQuestionnaire_header__2LU1W","info":"PatientQuestionnaire_info__31qWK"};